import { container } from '@_plugins/ioc';
import LaravelAPI from '@data/api/laravel.api';
import { toJobModel } from '@data/dto/job-model.dto';
import { Meta, PaginateResult } from '@data/models/api.interface';
import { FilterParams } from '@data/models/filter.interface';
import { JobModel, JobModelHttp } from '@data/models/job-model.interface';
import ErrorService from 'core/error.service';
import { injectable } from 'inversify';

@injectable()
export default class JobModelService {
  private API = container.get<LaravelAPI>(LaravelAPI);
  private readonly jobModelEndpoint = '/job-models';
  private errorService = container.get<ErrorService>(ErrorService);

  public async listJobModels(
    filters: FilterParams,
  ): Promise<PaginateResult<JobModel[]>> {
    const result = await this.API.get<{
      data: JobModelHttp[];
      meta: Meta;
    }>(this.jobModelEndpoint, filters);

    if (!result) {
      return {
        items: [],
        totalSize: 0,
      };
    }

    const { data: response, error } = result;

    if (error) {
      this.errorService.handleHttpError(error);
      return {
        items: [],
        totalSize: 0,
      };
    }

    return {
      items: response?.data?.map(toJobModel) || [],
      totalSize: response?.meta?.page?.total || 0,
    };
  }
}
